// Error monitoring via Sentry. Entirely inert unless REACT_APP_SENTRY_DSN is
// set at build time — without it no SDK is initialized and nothing is sent.

import * as Sentry from "@sentry/react";

const dsn = process.env.REACT_APP_SENTRY_DSN;

export const initMonitoring = (): void => {
  if (!dsn) return;
  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV,
    // Errors only — no performance tracing or session replay, keeping the
    // bundle lean and avoiding extra data collection.
    tracesSampleRate: 0,
  });
};

/** Report a caught error (e.g. from an ErrorBoundary). No-op without a DSN. */
export const reportError = (error: unknown, context?: string): void => {
  if (!dsn) return;
  Sentry.captureException(error, context ? { tags: { context } } : undefined);
};
